import { isNotNullOrUndefined, vyDate } from '@vy/utils';
import { isEmptyString, isString } from '@vy/string';
import { resolveDatePreset } from '../../../../components/new-design/vyTableFilter/date-preset-consts';

export function asStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((entry): entry is string => typeof entry === 'string');
  }

  if (typeof value === 'string' && value.length > 0) {
    return [value];
  }

  return [];
}

export function matchesStringSelection(
  value: string | null | undefined,
  selected: unknown,
): boolean {
  const selections = asStringArray(selected);

  if (selections.length === 0) {
    return true;
  }

  return isNotNullOrUndefined(value) && selections.includes(value);
}

export function matchesStringArrayIntersection(
  values: readonly (string | null | undefined)[],
  selected: unknown,
): boolean {
  const selections = asStringArray(selected);

  if (selections.length === 0) {
    return true;
  }

  return values.some((value) => isNotNullOrUndefined(value) && selections.includes(value));
}

export function matchesLabelSelection(labelIds: readonly string[], selected: unknown): boolean {
  return matchesStringArrayIntersection(labelIds, selected);
}

export function matchesText(value: string | null | undefined, filterValue: unknown): boolean {
  if (!isString(filterValue) || isEmptyString(filterValue)) {
    return true;
  }

  if (isEmptyString(value)) {
    return false;
  }

  return value.toLowerCase().includes(filterValue.toLowerCase());
}

export function matchesDatePreset(
  date: Date | string | null | undefined,
  value: unknown,
): boolean {
  if (typeof value !== 'string') return true;
  const range = resolveDatePreset(value);
  if (!range) return true;
  if (!date) return false;

  const day = vyDate(date);
  if (!day.isValid()) return false;

  // Compare at day granularity in the user's local time zone so a contract
  // starting at any time on a given day matches a range that includes that day.
  const dayMs = day.startOf('day').valueOf();
  const fromMs = vyDate(range.from).startOf('day').valueOf();
  const toMs = vyDate(range.to).startOf('day').valueOf();

  return dayMs >= fromMs && dayMs <= toMs;
}
